import React from "react";
import Project from "./index";

export function ProjectDeferred() {
  return <Project status="Reporté" />;
}
